module.exports = __webpack_public_path__ + "static/media/Cottonv5.0.0ae6f32e.PNG";